// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"446825ce","496":"698ed3f2","787":"8c8f3fe0"}[chunkId] + ".chunk.js";
};